<template>
  <validation-provider
    v-slot="{ errors, valid, classes }"
    v-bind="groupedAttrs.validator"
    slim
  >
    <base-input
      ref="field"
      v-bind="groupedAttrs.input"
      :errors="errors"
      :valid="valid && classes.validated && !!value"
      :value="value"
      v-on="inputListeners"
      @input="handleInput"
    >
      <template
        v-for="(_, name) in inputSlots"
        :slot="name"
        slot-scope="slotData"
      >
        <slot :name="name" v-bind="slotData" />
      </template>
    </base-input>
  </validation-provider>
</template>

<script>
export default {
  name: "BaseInputWithValidation",
  inheritAttrs: false,
  props: {
    value: {},
  },
  computed: {
    inputListeners() {
      // eslint-disable-next-line no-unused-vars
      const { input, ...rest } = this.$listeners;
      return rest;
    },
    inputSlots() {
      const { append, prepend } = this.$scopedSlots;
      return { append, prepend };
    },
    groupedAttrs() {
      // разделяем биндинги валидатора и инпута
      const { vid, mode, tag, rules, ...rest } = this.$attrs;

      return {
        input: rest,
        validator: {
          vid,
          mode,
          tag,
          rules,
          name: rest.name,
        },
      };
    },
  },
  created() {
    this.focus = () => {
      this.$refs.field.focus();
    };
  },
  methods: {
    handleInput(val) {
      this.$emit("input", val);
    },
  },
};
</script>
